'use strict';

const { isMobile } = require('./utilities/breakpoints');

$(document).ready(function () {

    var step1Response;
    var step2Response;
    var step3Response;
    var jsonData = $(".json-primer").attr("data-json");
    jsonData = JSON.parse(jsonData);
    var getProductUrl = $(".get-product-url").attr("data-url");
    var language= $(".get-language").attr("data-lang");
    var country= $(".get-country").attr("data-country");
    var dataGtmProduct = $(".js_primer-finder-product").attr("data-url");

    var resultText = jsonData["resultText"][language] ? jsonData["resultText"][language] : jsonData["resultText"];
    var resultSubText = jsonData["resultSubText"][language] ? jsonData["resultSubText"][language] : jsonData["resultSubText"];
    var questionToUse = jsonData["question"][language] ? jsonData["question"][language] : jsonData["question"];
    var subquestionToUse = jsonData["subquestion"][language] ? jsonData["subquestion"][language] : jsonData["subquestion"];
    var nextButton = jsonData["nextButton"] && jsonData["nextButton"][language] ? jsonData["nextButton"][language] : jsonData["nextButton"];
    var discoverPrimerButton = jsonData["discoverPrimerButton"] && jsonData["discoverPrimerButton"][language] ? jsonData["discoverPrimerButton"][language] : jsonData["discoverPrimerButton"];
    var shopNowButton = jsonData["shopNowButton"] && jsonData["shopNowButton"][language] ? jsonData["shopNowButton"][language] : jsonData["shopNowButton"];
    var startAgainButton = jsonData["startAgainButton"] && jsonData["startAgainButton"][language] ? jsonData["startAgainButton"][language] : jsonData["startAgainButton"];

    if (nextButton) {
        $(".step1").text(nextButton);
        $(".step2").text(nextButton);
    }

    if (discoverPrimerButton) {
        $(".final-step").text(discoverPrimerButton);
        $(".step3").text(discoverPrimerButton);
    }

    if (shopNowButton) {
        $(".shop-now").text(shopNowButton);
    }

    if (startAgainButton) {
        $(".start-again").text(startAgainButton);
    }

    $(".step-1 .question-primer").text(questionToUse);
    $(".step-1 .subquestion-primer").text(subquestionToUse);
    $(".result-primer").text(resultText);
    $(".sub-result-primer").text(resultSubText);

    var htmlStep1 = "";
    for (var prop in jsonData["options"]) {
        var option = jsonData["options"][prop];
        var textToUse = option.text[language] ? option.text[language] : option.text;

        if (!isMobile()) {
            htmlStep1 = htmlStep1 + "<div class='response-element'><label class='label-select-response'><input type='radio' value=" + prop +" class='select-response-input' name='step1-selectedResponse' />";
            htmlStep1 = htmlStep1 + "<div class='image-response'><img class='image-display' src=" + option.image +"/></diV><div class='text-response'>" + textToUse + "</div><div class='radio-checkmark'><div class='radio-check'></div></div></label></div>"
        } else {
            htmlStep1 = htmlStep1 + "<div class='response-element'><label class='label-select-response'><input type='radio' value=" + prop + " class='select-response-input' name='step1-selectedResponse' />";
            htmlStep1 = htmlStep1 + "<div class='text-response'>" + textToUse + "</div><div class='radio-checkmark'><div class='radio-check'></div></div><div class='image-response'><img class='image-display' src=" + option.image +"/></div></label></div>";
        }
    }
    if (!isMobile()) {
        $(".response-options-desktop-step1").append(htmlStep1);
    } else {
        $(".response-options-mobile-step1").append(htmlStep1);
    }

    $(".footer-content-1.container").hide();

    $('.primer-button').on('click', function(){
        $('.primer-finder-page').slick("slickNext");
        $("html, body").animate({ scrollTop: 0 }, "slow");
    });

    $('.back-button').on('click', function() {
        $('.primer-finder-page').slick("slickPrev");
        $("html, body").animate({ scrollTop: 0 }, "slow");
    });

    $("input[name='step1-selectedResponse']").on("change", function() {
        $('.step1').css({display: "block"});
        if (isMobile()) {
            $(".step1").detach().appendTo("#primer-finder-page").addClass("sticky-button");
        }
    });

    // Skip the intermediate step.
    $(".step-1 .select-response-input").on("click", function() {
        var choice1 = $('input[name="step1-selectedResponse"]:checked').val();
        var response = jsonData["options"][choice1];
        if (!response.hasOwnProperty('nextStep')){
            $(".step-1 .step1").addClass("hide");
            $(".step-1 .final-step").removeClass("hide");
            if (isMobile()) {
                $(".step-1 .step1").detach().appendTo("#primer-finder-page").addClass("sticky-button");
                $(".step-1 .final-step").detach().appendTo("#primer-finder-page").addClass("sticky-button");
            }
        } else {
            $(".step-1 .step1").removeClass("hide");
            $(".step-1 .final-step").addClass("hide");
        }
    });

    $('.step-1 .final-step').on("click", function() {
        var choice1 = $('input[name="step1-selectedResponse"]:checked').val();
        var finalStep= jsonData["options"][choice1];
        if (!finalStep.hasOwnProperty('nextStep')){
            dataLayer.push({
                'event':'primer_finder_question',
                'pf_question':{
                    'parcours': jsonData["options"][choice1]["text"]["en"] ||jsonData["options"][choice1]["text"],
                    'step': '1'
                }
            });
            $.spinner().start();
            var productId = finalStep.result.productId;
            var resultImage = finalStep.result.image;
            getProductUrl = getProductUrl + productId + "&l=" + language + "&c=" + country;
            $.ajax({
                url: getProductUrl,
                method: 'GET',
                dataType: 'json',
                success: function (dataJson) {
                    if (dataJson.product) {
                        var product = dataJson.product;
                        var imageHtml = "<img class='image-display' src="+ product.imageUrl.url +" alt=" + product.imageUrl.alt + " />";
                        $(".sub-title").text(product.productSubName);
                        $(".title-product").text(product.productName);
                        if (product.colorShade) {
                            $(".name-shade").text(product.colorShade);
                        }
                        $(".description-product").append(product.shortDescription);
                        $(".product-image").append(imageHtml);
                        $("#primer-finder-page").remove();
                        $(".primer-finder-result").show();
                        $('.shop-now-href').attr("href", product.selectedProductUrl);
                        $(".result-image").append("<img class='image-display' src=" + resultImage +"/>");
                        $("html, body").animate({ scrollTop: 0 }, "slow");
                        $.spinner().stop();
                    }
                }
            });
            // Tagging
            dataGtmProduct = dataGtmProduct + "?product=" + productId;
            $.ajax({
                url: dataGtmProduct,
                type: 'get',
                dataType: 'json',
                success: function (data) {
                    dataLayer.push(data.productGtm);
                    $('.shop-now').data("product-id", productId);
                },
                error: function (err) {
                    console.error("Error on GTM", err)
                }
            })
        }
    });

    $(".step1").on("click", function() {
        var choice1 = $('input[name="step1-selectedResponse"]:checked').val();
        if (isMobile()) {
            $(".step1").addClass("hide");
        }
        if (choice1) {
            dataLayer.push({
                'event':'primer_finder_question',
                'pf_question':{
                    'parcours': jsonData["options"][choice1]["text"]["en"] ||jsonData["options"][choice1]["text"],
                    'step': '1'
                }
            });
            step1Response = jsonData["options"][choice1].nextStep;
            var textQuestion = step1Response["question"][language] ? step1Response["question"][language] : step1Response["question"];
            $(".step-2 .question-primer").text(textQuestion);
            var htmlStep2 = "";
            var mobileOptions = [];
            for (var prop in step1Response["options"]) {
                var option = step1Response["options"][prop];
                var textToUse = option.text[language] ? option.text[language] : option.text;
                var optionsCount = Object.keys(step1Response["options"]).length;

                if (!isMobile()) {
                    htmlStep2 = htmlStep2 + "<div class='response-element'><label class='label-select-response'><input type='radio' value=" + prop +" class='select-response-input' name='step2-selectedResponse' />";
                    htmlStep2 = htmlStep2 + "<div class='image-response'><img class='image-display' src=" + option.image +"/></diV><div class='text-response'>" + textToUse + "</div><div class='radio-checkmark'><div class='radio-check'></div></div></label></div>"
                } else if (!isMobile() && optionsCount < 3) {
                    htmlStep2 = htmlStep2 + "<div class='response-element'><label class='label-select-response'><input type='radio' value=" + prop + " class='select-response-input' name='step2-selectedResponse' />";
                    htmlStep2 = htmlStep2 + "<div class='text-response'>" + textToUse + "</div><div class='radio-checkmark'><div class='radio-check'></div></div><div class='image-response'><img class='image-display' src=" + option.image +"/></div></label></div>";
                } else {
                    var mobileOption = {
                        text: textToUse,
                        property: prop,
                        image: option.image
                    }
                    mobileOptions.push(mobileOption);
                }
            }

            if (mobileOptions.length && !htmlStep2) {
                htmlStep2 = "<div class='response-element-caroussel'><div class='text-response-caroussel'>" + mobileOptions[0].text + "</div><div class='radio-checkmark-caroussel'><div class='radio-check-checked'></div></div><div class='images-caroussel'>";
                for (var i=0; i<mobileOptions.length; i++) {
                    htmlStep2 = htmlStep2 + "<div class='image-response-caroussel'><img class='mobile-caroussel-image' src=" + mobileOptions[i].image + " alt=" + mobileOptions[i].property + " /></div>"
                }
                htmlStep2 = htmlStep2 + "</div></div>"
                $(".step2").detach().appendTo("#primer-finder-page").addClass("sticky-button");
                $('.step2').css({display: "block"});
            }

            if (!isMobile()) {
                $(".response-options-desktop-step2").empty().append(htmlStep2);
            } else {
                $(".response-options-mobile-step2").empty().append(htmlStep2);
            }

            if (mobileOptions.length) {
                $('.images-caroussel').slick({
                    slidesToShow: 1,
                    centerPadding: '0',
                    arrows: true,
                    swipe: false,
                    nextArrow: '<a class="next-arrow"><span class="icon-CHEVRON"></span></a>',
                    prevArrow: '<a class="prev-arrow"><span class="icon-CHEVRON"></span></a>',
                    initialSlide: 0,
                    responsive: [{
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            initialSlide: 0,
                            arrows: true,
                            swipe: true,
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                            initialSlide: 0,
                            centerMode: true,
                            centerPadding: '95px',
                            arrows: true,
                            swipe: true
                        }
                    }]
                });

                var selectedOption = $('.images-caroussel .slick-current img.mobile-caroussel-image').attr('alt');
                var response = step1Response["options"][selectedOption];
                if (!response.nextStep) {
                    $(".step2").addClass("hide");
                    $(".final-step").removeClass("hide");
                }
                $(".step2").detach().appendTo("#primer-finder-page").addClass("sticky-button");
                $(".final-step").detach().appendTo("#primer-finder-page").addClass("sticky-button");

                $('.images-caroussel').on('afterChange', function() {
                    selectedOption = $('.images-caroussel .slick-current img.mobile-caroussel-image').attr('alt');
                    var response = step1Response["options"][selectedOption];
                    if (response.nextStep) {
                        $(".step2").removeClass("hide");
                        $(".final-step").addClass("hide");
                    } else {
                        $(".step2").addClass("hide");
                        $(".final-step").removeClass("hide");
                    }
                    for (var i=0; i<mobileOptions.length; i++) {
                        if (selectedOption === mobileOptions[i].property) {
                            $(".text-response-caroussel").text(mobileOptions[i].text);

                            break;
                        }
                    }
                });

                $('.owl-next').on('click', function() {
                    $('.images-caroussel').slick("slickNext");
                });

                $('.owl-prev').on('click', function(){
                    $('.images-caroussel').slick("slickPrev");
                });
            }

            if (isMobile()) {
                $(".step2").detach().appendTo("#primer-finder-page").addClass("sticky-button");
                $(".final-step").detach().appendTo("#primer-finder-page").addClass("sticky-button");
            }

            $("input[name='step2-selectedResponse']").on("change", function() {
                $('.step2').css({display: "block"});
                var actualValue = $(this).val();
                var response = step1Response["options"][actualValue];
                if (response.nextStep) {
                    $(".step2").removeClass("hide");
                    $(".final-step").addClass("hide");
                } else {
                    $(".step2").addClass("hide");
                    $(".final-step").removeClass("hide");
                }
            });

            $(".step2, .final-step").on("click", function() {
                var choice2, htmlStep3;
                if (!isMobile()) {
                    choice2 = $('input[name="step2-selectedResponse"]:checked').val();
                    if (choice2) {
                        step2Response = step1Response["options"][choice2];
                        dataLayer.push({
                            'event':'primer_finder_question',
                            'pf_question':{
                                'parcours': jsonData["options"][choice1]["text"]["en"] ||jsonData["options"][choice1]["text"],
                                'step': '2'
                            }
                        });
                        dataLayer.push({
                            'event':'primer_finder_answer',
                            'pf_answer':{
                                'step': '2',
                                'choice': step2Response["text"]["en"] || step2Response["text"]
                            }
                        });

                        if (step2Response.nextStep) {
                            step2Response = step2Response.nextStep;
                            var step3Question = step2Response["question"][language] ? step2Response["question"][language] :step2Response["question"];
                            $(".step-3 .question-primer").text(step3Question);
                            htmlStep3 = "";
                            for (var prop in step2Response["options"]) {
                                var option = step2Response["options"][prop];
                                var textToUse = option.text[language] ? option.text[language] : option.text;
                                htmlStep3 = htmlStep3 + "<div class='response-element'><label class='label-select-response'><input type='radio' value=" + prop +" class='select-response-input' name='step3-selectedResponse' />";
                                htmlStep3 = htmlStep3 + "<div class='image-response'><img class='image-display' src=" + option.image +"/></diV><div class='text-response'>" + textToUse + "</div><div class='radio-checkmark'><div class='radio-check'></div></div></label></div>"
                            }
                            $(".response-options-desktop-step3").empty().append(htmlStep3);

                            $("input[name='step3-selectedResponse']").on("change", function() {
                                $('.step3').css({display: "block"});
                            });

                            $(".step3").on('click', function() {
                                $.spinner().start();
                                var choice3 = $('input[name="step3-selectedResponse"]:checked').val();
                                step3Response = step2Response["options"][choice3];
                                dataLayer.push({
                                    'event':'primer_finder_question',
                                    'pf_question':{
                                        'parcours': jsonData["options"][choice1]["text"]["en"] ||jsonData["options"][choice1]["text"],
                                        'step': '3'
                                    }
                                });
                                dataLayer.push({
                                    'event':'primer_finder_answer',
                                    'pf_answer':{
                                        'step': '3',
                                        'choice': step3Response["text"]["en"] || step3Response["text"]
                                    }
                                });
                                var productId = step3Response.result.productId;
                                var resultImage = step3Response.result.image;
                                getProductUrl = getProductUrl + productId + "&l=" + language + "&c=" + country;
                                $.ajax({
                                    url: getProductUrl,
                                    method: 'GET',
                                    dataType: 'json',
                                    success: function (dataJson) {
                                        if (dataJson.product) {
                                            var product = dataJson.product;
                                            var imageHtml = "<img class='image-display' src="+ product.imageUrl.url +" alt=" + product.imageUrl.alt + " />";
                                            $(".sub-title").text(product.productSubName);
                                            $(".title-product").text(product.productName);
                                            if (product.colorShade) {
                                                $(".name-shade").text(product.colorShade);
                                            }
                                            $(".description-product").append(product.shortDescription);
                                            $(".product-image").append(imageHtml);
                                            $("#primer-finder-page").remove();
                                            $(".primer-finder-result").show();
                                            $('.shop-now-href').attr("href", product.selectedProductUrl);
                                            $(".result-image").append("<img class='image-display' src=" + resultImage +"/>");
                                            $("html, body").animate({ scrollTop: 0 }, "slow");
                                            $.spinner().stop();
                                        }
                                    }
                                });
                                // Tagging
                                dataGtmProduct = dataGtmProduct + "?product=" + productId;
                                $.ajax({
                                    url: dataGtmProduct,
                                    type: 'get',
                                    dataType: 'json',
                                    success: function (data) {
                                        dataLayer.push(data.productGtm);
                                        $('.shop-now').data("product-id", productId);
                                    },
                                    error: function (err) {
                                        console.error("Error on GTM", err)
                                    }
                                });
                            });
                        } else {
                            $.spinner().start();
                            var productId = step2Response.result.productId;
                            var resultImage = step2Response.result.image;
                            getProductUrl = getProductUrl + productId + "&l=" + language + "&c=" + country;
                            $.ajax({
                                url: getProductUrl,
                                method: 'GET',
                                dataType: 'json',
                                success: function (dataJson) {
                                    if (dataJson.product) {
                                        var product = dataJson.product;
                                        var imageHtml = "<img class='image-display' src="+ product.imageUrl.url +" alt=" + product.imageUrl.alt + " />";
                                        $(".sub-title").text(product.productSubName);
                                        $(".title-product").text(product.productName);
                                        if (product.colorShade) {
                                            $(".name-shade").text(product.colorShade);
                                        }
                                        $(".description-product").append(product.shortDescription);
                                        $(".product-image").append(imageHtml);
                                        $("#primer-finder-page").remove();
                                        $(".primer-finder-result").show();
                                        $('.shop-now-href').attr("href", product.selectedProductUrl);
                                        $(".result-image").append("<img class='image-display' src=" + resultImage +"/>");
                                        $("html, body").animate({ scrollTop: 0 }, "slow");
                                        $.spinner().stop();
                                    }
                                }
                            });
                            // Tagging
                            dataGtmProduct = dataGtmProduct + "?product=" + productId;
                            $.ajax({
                                url: dataGtmProduct,
                                type: 'get',
                                dataType: 'json',
                                success: function (data) {
                                    dataLayer.push(data.productGtm);
                                    $('.shop-now').data("product-id", productId);
                                },
                                error: function (err) {
                                    console.error("Error on GTM", err)
                                }
                            });
                        }
                    }
                } else {
                    $(".step2").addClass("hide");
                    if (optionsCount < 3) {
                        choice2 = $('input[name="step2-selectedResponse"]:checked').val();
                    } else if (selectedOption) {
                        choice2 = selectedOption;
                    }
                    if (choice2) {
                        step2Response = step1Response["options"][choice2];
                        dataLayer.push({
                            'event':'primer_finder_question',
                            'pf_question':{
                                'parcours': jsonData["options"][choice1]["text"]["en"] ||jsonData["options"][choice1]["text"],
                                'step': '2'
                            }
                        });
                        dataLayer.push({
                            'event':'primer_finder_answer',
                            'pf_answer':{
                                'step': '2',
                                'choice': step2Response["text"]["en"] || step2Response["text"]
                            }
                        });
                        if (step2Response.nextStep) {
                            step2Response = step2Response.nextStep;
                            var questionToUse = step2Response["question"][language] ? step2Response["question"][language] : step2Response["question"];
                            $(".step-3 .question-primer").text(questionToUse);
                            htmlStep3 = "";
                            var secondMobileOptions = [];
                            for (var prop in step2Response["options"]) { // eslint-disable-line
                                var option = step2Response["options"][prop]; // eslint-disable-line
                                var textToUse = option.text[language] ? option.text[language] : option.text; // eslint-disable-line
                                var secondOptionsCount = Object.keys(step2Response["options"]).length;
                                if (secondOptionsCount < 3) {
                                    htmlStep3 = htmlStep3 + "<div class='response-element'><label class='label-select-response'><input type='radio' value=" + prop + " class='select-response-input' name='step3-selectedResponse' />";
                                    htmlStep3 = htmlStep3 + "<div class='text-response'>" + textToUse + "</div><div class='radio-checkmark'><div class='radio-check'></div></div><div class='image-response'><img class='image-display' src=" + option.image +"/></div></label></div>";
                                } else {
                                    var secondMobileOption = {
                                        text: textToUse,
                                        property: prop,
                                        image: option.image
                                    }
                                    secondMobileOptions.push(secondMobileOption);
                                }
                            }

                            if (secondMobileOptions.length && !htmlStep3) {
                                htmlStep3 = "<div class='response-element-caroussel'><div class='text-response-caroussel2'>" + secondMobileOptions[0].text + "</div><div class='radio-checkmark-caroussel'><div class='radio-check-checked'></div></div><div class='images-caroussel2'>";
                                for (var i=0; i<secondMobileOptions.length; i++) {
                                    htmlStep3 = htmlStep3 + "<div class='image-response-caroussel'><img class='mobile-caroussel-image' src=" + secondMobileOptions[i].image + " alt=" + secondMobileOptions[i].property + " /></div>"
                                }
                                htmlStep3 = htmlStep3 + "</div></div>"
                                $('.step3').css({display: "block"});
                            }
                            $(".response-options-mobile-step3").empty().append(htmlStep3);
                            $(".step3").detach().appendTo("#primer-finder-page").addClass("sticky-button");
                            $("input[name='step3-selectedResponse']").on("change", function() {
                                $('.step3').css({display: "block"});
                            });

                            if (secondMobileOptions.length) {
                                $('.images-caroussel2').slick({
                                    slidesToShow: 1,
                                    centerPadding: '0',
                                    arrows: true,
                                    swipe: false,
                                    nextArrow: '<a class="next-arrow"><span class="icon-CHEVRON"></span></a>',
                                    prevArrow: '<a class="prev-arrow"><span class="icon-CHEVRON"></span></a>',
                                    initialSlide: 0,
                                    responsive: [{
                                        breakpoint: 1024,
                                        settings: {
                                            slidesToShow: 1,
                                            slidesToScroll: 1,
                                            initialSlide: 0,
                                            arrows: true,
                                            swipe: true,
                                        }
                                    },
                                    {
                                        breakpoint: 768,
                                        settings: {
                                            slidesToShow: 1,
                                            initialSlide: 0,
                                            centerMode: true,
                                            centerPadding: '95px',
                                            arrows: true,
                                            swipe: true
                                        }
                                    }]
                                });

                                selectedOption = $('.images-caroussel2 .slick-current img.mobile-caroussel-image').attr('alt');
                                $('.images-caroussel2').on('afterChange', function() {
                                    selectedOption = $('.images-caroussel2 .slick-current img.mobile-caroussel-image').attr('alt');
                                    for (var i=0; i<secondMobileOptions.length; i++) {
                                        if (selectedOption === secondMobileOptions[i].property) {
                                            $(".text-response-caroussel2").text(secondMobileOptions[i].text);
                                        }
                                    }
                                });

                                $('.owl-next').on('click', function() {
                                    $('.images-caroussel2').slick("slickNext");
                                });

                                $('.owl-prev').on('click', function(){
                                    $('.images-caroussel2').slick("slickPrev");
                                });
                            }

                            $(".step3").on('click', function() {
                                var choice3;
                                $(".step3").addClass("hide");
                                $.spinner().start();
                                if (secondMobileOptions < 3) {
                                    choice3 = $('input[name="step3-selectedResponse"]:checked').val();
                                } else {
                                    choice3 = selectedOption;
                                }
                                if (choice3) {
                                    step3Response = step2Response["options"][choice3];
                                    dataLayer.push({
                                        'event':'primer_finder_question',
                                        'pf_question':{
                                            'parcours': jsonData["options"][choice1]["text"]["en"] ||jsonData["options"][choice1]["text"],
                                            'step': '3'
                                        }
                                    });
                                    dataLayer.push({
                                        'event':'primer_finder_answer',
                                        'pf_answer':{
                                            'step': '3',
                                            'choice': step3Response["text"]["en"] || step3Response["text"]
                                        }
                                    });
                                    var productId = step3Response.result.productId;
                                    var resultImage = step3Response.result.image;
                                    getProductUrl = getProductUrl + productId + "&l=" + language + "&c=" + country;
                                    $.ajax({
                                        url: getProductUrl,
                                        method: 'GET',
                                        dataType: 'json',
                                        success: function (dataJson) {
                                            if (dataJson.product) {
                                                var product = dataJson.product;
                                                var imageHtml = "<img class='image-display' src="+ product.imageUrl.url +" alt=" + product.imageUrl.alt + " />";
                                                $(".sub-title").text(product.productSubName);
                                                $(".title-product").text(product.productName);
                                                if (product.colorShade) {
                                                    $(".name-shade").text(product.colorShade);
                                                }
                                                $(".description-product").append(product.shortDescription);
                                                $(".product-image").append(imageHtml);
                                                $("#primer-finder-page").remove();
                                                $(".primer-finder-result").show();
                                                $('.shop-now-href').attr("href", product.selectedProductUrl);
                                                $(".result-image").append("<img class='image-display' src=" + resultImage +"/>");
                                                $("html, body").animate({ scrollTop: 0 }, "slow");
                                                $.spinner().stop();
                                            }
                                        }
                                    });
                                    // Tagging
                                    dataGtmProduct = dataGtmProduct + "?product=" + productId;
                                    $.ajax({
                                        url: dataGtmProduct,
                                        type: 'get',
                                        dataType: 'json',
                                        success: function (data) {
                                            dataLayer.push(data.productGtm);
                                            $('.shop-now').data("product-id", productId);
                                        },
                                        error: function (err) {
                                            console.error("Error on GTM", err)
                                        }
                                    });
                                }
                            });
                        } else {
                            $.spinner().start();
                            var productId = step2Response.result.productId; // eslint-disable-line
                            var resultImage = step2Response.result.image; // eslint-disable-line
                            getProductUrl = getProductUrl + productId + "&l=" + language + "&c=" + country;
                            $.ajax({
                                url: getProductUrl,
                                method: 'GET',
                                dataType: 'json',
                                success: function (dataJson) {
                                    if (dataJson.product) {
                                        var product = dataJson.product;
                                        var imageHtml = "<img class='image-display' src="+ product.imageUrl.url +" alt=" + product.imageUrl.alt + " />";
                                        $(".sub-title").text(product.productSubName);
                                        $(".title-product").text(product.productName);
                                        if (product.colorShade) {
                                            $(".name-shade").text(product.colorShade);
                                        }
                                        $(".description-product").append(product.shortDescription);
                                        $(".product-image").append(imageHtml);
                                        $("#primer-finder-page").remove();
                                        $(".primer-finder-result").show();
                                        $('.shop-now-href').attr("href", product.selectedProductUrl);
                                        $(".result-image").append("<img class='image-display' src=" + resultImage +"/>");
                                        $("html, body").animate({ scrollTop: 0 }, "slow");
                                        $.spinner().stop();
                                    }
                                }
                            });
                            // Tagging
                            dataGtmProduct = dataGtmProduct + "?product=" + productId;
                            $.ajax({
                                url: dataGtmProduct,
                                type: 'get',
                                dataType: 'json',
                                success: function (data) {
                                    dataLayer.push(data.productGtm);
                                    $('.shop-now').data("product-id", productId);
                                },
                                error: function (err) {
                                    console.error("Error on GTM", err)
                                }
                            });
                        }
                    }
                }
            });

        }
    });
    $(".start-again").on("click", function() {
        window.dataLayer.push({
            'event': "primer_finder_click",
            'cta_name': $(this)[0].innerText.toLowerCase()
        });
    });
    $(".shop-now").on("click", function() {
        window.dataLayer.push({
            'event': "primer_finder_click",
            'cta_name': $(this)[0].innerText.toLowerCase()
        });
        // Push productClick event Primer Finder to GTM.
        var productId = $(this).data("product-id");
        dataGtmProduct = dataGtmProduct + "?product=" + productId;
        $.ajax({
            url: dataGtmProduct,
            type: 'get',
            dataType: 'json',
            success: function (data) {
                window.dataLayer.push(data.primerFinderResultGtm);
            },
            error: function (err) {
                console.error("Error on GTM", err)
            }
        });
    });
    $(".final-step").on("click", function() {
        window.dataLayer.push({
            'event': "primer_finder_click",
            'cta_name': $(this)[0].innerText.toLowerCase()
        });
    });
    $(".button-start").on("click", function() {
        window.dataLayer.push({
            'event': "primer_finder_click",
            'cta_name': $(this)[0].innerText.toLowerCase()
        });
    });
});
